import type {ElementTestId} from '@Tests/tests.types';

export enum PosterAddItemBarHeightThreshold {
  MINIMUM = 'minimum',
  XXXSMALL = 'XXXSMALL',
  XXSMALL = 'XXSMALL',
  XSMALL = 'XSMALL',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  XLARGE = 'XLARGE',
  XXLARGE = 'XXLARGE',
  XXXLARGE = 'XXXLARGE',
}

export interface AddItemOptionsProps {
  popupClassName?: string;
  arrowClasses?: string;
  isSmallHeight?: boolean;
  'data-testid'?: ElementTestId;
  isHidden?: boolean;
}

export interface AddItemDropdownProps {
  className?: string;
  onOpenModal?(): void;
}

export const ADD_ITEM_BAR_POPUP_OFFSET = 24;
export const ADD_ITEM_BAR_TOP_OFFSET = -8;
